import { useEffect, useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';

import { useApi } from '../../hooks/useApi';
import { useAuth } from '../../hooks/useAuth';
import { claimPendingReferral } from '../../utils/attribution';

function YandexAuthCallbackPage() {
    const { request } = useApi();
    const { login } = useAuth();
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const [message, setMessage] = useState('Завершаем вход через Яндекс...');
    const code = searchParams.get('code') || '';
    const state = searchParams.get('state') || '';

    useEffect(() => {
        if (!code || !state) {
            setMessage('Не удалось завершить вход: отсутствует code или state.');
            return;
        }

        let cancelled = false;

        const completeAuth = async () => {
            try {
                const tokenResponse = await request('/api/v1/auth/oauth/yandex/complete', {
                    method: 'POST',
                    body: JSON.stringify({ code, state }),
                });
                if (cancelled) return;
                login(tokenResponse);
                await claimPendingReferral(request, tokenResponse?.access_token);
                navigate('/', { replace: true });
            } catch (error) {
                if (!cancelled) {
                    setMessage(error.message || 'Не удалось завершить вход через Яндекс.');
                }
            }
        };

        completeAuth();

        return () => {
            cancelled = true;
        };
    }, [code, state, request, login, navigate]);

    return (
        <div className="app">
            <main className="app__shell">
                <section className="panel panel--auth">
                    <h1>Вход через Яндекс</h1>
                    <p>{message}</p>
                    <Link className="button-link" to="/">
                        Вернуться на главную
                    </Link>
                </section>
            </main>
        </div>
    );
}

export default YandexAuthCallbackPage;
